module.exports = __webpack_public_path__ + "static/media/Configuración_Plazas.8282a7c1.svg";